// prod
// https://merakigemstones.com
// dev
// http://dev.merakigemstones.com:3000
// local
// ''
export const SERVER_ENDPOINT = 'https://merakigemstones.com';
export const API_ENDPOINT = SERVER_ENDPOINT +  '/api/';